import { Mail, ArrowUpRight } from "lucide-react";

export default function Support() {
  return (
    <section
      id="support"
      data-testid="support-section"
      className="py-24 lg:py-32 px-6 lg:px-10 bg-neutral-50 border-y border-neutral-200"
    >
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-violet-500/10 border border-violet-500/20 mb-6">
          <Mail size={22} className="text-violet-600" />
        </div>
        <p className="text-sm font-medium text-violet-600 mb-4 uppercase tracking-wider">
          Support
        </p>
        <h2
          data-testid="support-title"
          className="text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.1] text-neutral-950 mb-6"
        >
          Une question ? On est là.
        </h2>
        <p className="text-lg text-neutral-600 leading-relaxed mb-10 max-w-xl mx-auto">
          Notre équipe répond généralement en moins de 24 heures. Écris-nous à
          l'adresse ci-dessous.
        </p>
        <a
          href="mailto:contact@liftai.fr"
          data-testid="support-email-link"
          className="group inline-flex items-center gap-3 bg-neutral-950 text-white text-base font-medium px-6 py-3.5 rounded-full hover:bg-violet-600 transition-all duration-300"
        >
          contact@liftai.fr
          <ArrowUpRight
            size={18}
            className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
          />
        </a>
      </div>
    </section>
  );
}
